import api from "./api";
const endpoint = "/volontariat/PropositionTechFi";
export const PropositionTechniqueFinanciereService = {
  async insert(data, file_data = null) {
    try {
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      if (file_data) {
        formData.append("file", file_data);
      }

      const result = await api.post(endpoint + "/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(data, file_data = null) {
    try {
      //const result = await api.put(endpoint + "/update", filtre);
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      if (file_data) {
        formData.append("file", file_data);
      }

      const result = await api.post(endpoint + "/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async addComment(data, file_data = null) {
    try {
      //const result = await api.put(endpoint + "/update", filtre);
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      if (file_data) {
        formData.append("file", file_data);
      }

      const result = await api.post(endpoint + "/comment", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_one(data) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: data,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_by_uuid(id) {
    try {
      const result = await api.get(endpoint + "/findByUuid", {
        params: { uuid: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async liste(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
